export default {"src":"/_next/static/media/BoneFracturesDislocations.3eb5a0c8.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};